import { BookOpen } from "lucide-react";
import { PageHeader } from "../components/OperationalUI";

export default function Help() {
  return <div className="mx-auto max-w-4xl space-y-6" data-testid="help-page">
    <PageHeader eyebrow="Webstax" title="Help & Guidance" description="Support information for the Lutions platform." />
    <section className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700"><BookOpen aria-hidden="true"/></span>
      <h2 className="mt-5 text-xl font-black">Guidance is being updated</h2>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600">Webstax Help & Guidance is being updated as the Lutions platform develops.</p>
      <p className="mt-4 text-xs text-slate-500">Future guidance will be organised into accessible sections for each Lution.</p>
    </section>
  </div>;
}
